// The ship dates as of now, not as of the render.
//
// Shopify caches storefront pages, and Liquid reads 'now' when a page renders:
// a /pages/* copy has been served weeks old. So the server prints every date
// still open out to ten weeks (batch-next, ahead: true), each with the instant
// it closes, and this applies batch-next's rule again when the page is viewed.
//
// A [data-batch-dates] group holds dates marked [data-close] (epoch seconds),
// [data-listed] when typed in Batch mode, and data-ship / data-order-by.
// "first" shows the first open date; "upcoming" shows every open listed date,
// or when none is left, the next two on the rhythm. A group with nothing open
// hides. A ship calendar group also re-marks its days and shows only the
// months that hold a shown date.
(() => {
  const now = Date.now() / 1000;
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(new Date());

  for (const group of document.querySelectorAll('[data-batch-dates]')) {
    const dates = [...group.querySelectorAll('[data-close]')];
    const open = dates.filter((date) => Number(date.dataset.close) > now);
    const listed = open.filter((date) => date.hasAttribute('data-listed'));
    const shown = group.dataset.batchDates === 'first' ? open.slice(0, 1) : listed.length ? listed : open.slice(0, 2);
    for (const date of dates) date.hidden = !shown.includes(date);
    group.hidden = shown.length === 0;

    const ships = new Set(shown.map((date) => date.dataset.ship));
    const orderBys = new Set(shown.map((date) => date.dataset.orderBy));
    for (const day of group.querySelectorAll('.batch-calendar__date')) {
      const iso = day.getAttribute('datetime');
      const cell = day.parentElement;
      const ship = ships.has(iso);
      const orderBy = !ship && orderBys.has(iso);
      cell.classList.toggle('is-ship', ship);
      cell.classList.toggle('is-order-by', orderBy);
      cell.classList.toggle('is-past', iso < today);
      for (const mark of cell.querySelectorAll('[data-batch-mark]')) {
        mark.hidden = !(mark.dataset.batchMark === 'ship' ? ship : orderBy);
      }
    }
    for (const month of group.querySelectorAll('[data-batch-month]')) {
      const prefix = month.dataset.batchMonth;
      month.hidden = ![...ships, ...orderBys].some((iso) => iso.startsWith(prefix));
    }
  }
})();
